import PricingCard from "../common/pricing-cards/pricing-card";
import {
    businessPackInfo,
    corporatePackInfo,
    startupPackinfo,
} from "../home/sections/pricingPlanInfo";
import StartupPricingImage from "../../assets/images/pricing/startup.png";
import BusinessPricingImage from "../../assets/images/pricing/business.png";
import CorporatePricingImage from "../../assets/images/pricing/corporate.png";
import background from "../../assets/images/background.png";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import { useEffect } from "react";
import { SIGNUP_ROUTE } from "../../routes";

const ChoosePlan = ({history}) => {

    const handlePlanSelection = (plan) => {
        //console.log("Selected Plan",plan)
        history.push(SIGNUP_ROUTE , { plan });
    }

    useEffect(()=>{ 
        window.scrollTo({
            top: 0
        });
    },[])

    return (
        <div id="chose-plan" style={{ backgroundImage: `url(${background})` }}>
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">
                    Choose your Plan
                </h1>

                <div className="container-fluid">
                    <div
                        className="row row-cols-1 row-cols-md-1 row-cols-lg-3"
                        style={{ marginTop: "0rem", "--bs-gutter-y": "6rem" }}
                    >
                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={StartupPricingImage}
                                title="Start Up"
                                info="1-3 Agents"
                                price="110"
                                bg="#60C3AD"
                                points={startupPackinfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="STARTUP_PLAN_ID"
                            />
                        </div>

                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={BusinessPricingImage}
                                title="Business Builder"
                                info="4-12 Agents"
                                price="149"
                                bg="#3A7367"
                                points={businessPackInfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="BUSINESS_BUILDER_ID"
                            />
                        </div>

                        <div className="col-md d-flex justify-content-center">
                            <PricingCard
                                image={CorporatePricingImage}
                                title="Corporate"
                                info="12+ Agents"
                                price="189"
                                bg="#004B5B"
                                points={corporatePackInfo}
                                to={SIGNUP_ROUTE}
                                handler={handlePlanSelection}
                                plan="CORPORATE_PRICE_ID"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChoosePlan;
